import PeopleXDashboard from './PeopleXDashboard.component';

export default PeopleXDashboard;
